var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smartphone"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"frame"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }